import FilterHelper from './FiltersHelper'

class Filters {
  static InvoiceFilterExternal(filter, holidays) {
    // preventing errors, when we are passing wrong object or empty Date object
    // and rendering grid with all items
    if (!filter) return () => true

    const geMoment = FilterHelper.dateToMoment(filter.Date.Date.ge.value)
    const leMoment = FilterHelper.dateToMoment(filter.Date.Date.le.value)
    const geDate = geMoment.clone().startOf('day').valueOf()
    const upperDate = FilterHelper.getInvoiceUpperBoundMoment(geMoment, leMoment, holidays).valueOf()

    // creating callback for future use in filter method of array
    return (item) => {
      const itemDate = FilterHelper.dateToMoment(item.Date).startOf('day').valueOf()

      if (filter.Date && filter.Rep && filter.Rep.AcctR) {
        return itemDate >= geDate && itemDate <= upperDate && item.AcctR === filter.Rep.AcctR.eq
      }

      if (filter.Date && filter.Rep && filter.Rep.InvR) {
        return itemDate >= geDate && itemDate <= upperDate && item.InvR === filter.Rep.InvR.eq
      }

      return itemDate >= geDate && itemDate <= upperDate
    }
  }

  static InvoiceFilterInternal(gridRef, passedFilter, actionFilters, holidays) {
    if (Object.keys(actionFilters).length > 0) {

      const geMoment = FilterHelper.dateToMoment(actionFilters.Date.Date.ge.value)
      const leMoment = FilterHelper.dateToMoment(actionFilters.Date.Date.le.value)
      const geDate = geMoment.clone().startOf('day').valueOf()
      const upperDate = FilterHelper.getInvoiceUpperBoundMoment(geMoment, leMoment, holidays).valueOf()

      gridRef.collectionView.filter = (item) => {
        let filCols = passedFilter.filterColumns

        if (!filCols) {
          filCols = passedFilter.grid.columns.map((col) => col.binding)
        }

        for (let i = 0; i < filCols.length; i++) {
          let colBinding = filCols[i]
          let colFil = passedFilter.getColumnFilter(colBinding)
          if (!colFil.apply(item)) {
            return false
          }
        }

        const itemDate = FilterHelper.dateToMoment(item.Date).startOf('day').valueOf()

        if (actionFilters.Date && actionFilters.Rep && actionFilters.Rep.AcctR) {
          return itemDate >= geDate && itemDate <= upperDate && item.AcctR === actionFilters.Rep.AcctR.eq
        }

        if (actionFilters.Date && actionFilters.Rep && actionFilters.Rep.InvR) {
          return itemDate >= geDate && itemDate <= upperDate && item.InvR === actionFilters.Rep.InvR.eq
        }

        return itemDate >= geDate && itemDate <= upperDate
      }
    }
  }

  static SamplesFilterExternal(dateRange, holidays) {
    if (!dateRange) return () => true

    const geMoment = FilterHelper.dateToMoment(dateRange.Date.Date.ge.value)
    const leMoment = FilterHelper.dateToMoment(dateRange.Date.Date.le.value)
    const geDate = geMoment.clone().startOf('day').valueOf()
    const upperDate = FilterHelper.getInvoiceUpperBoundMoment(geMoment, leMoment, holidays).valueOf()

    return (item) => {
      const itemDate = FilterHelper.dateToMoment(item.Date).startOf('day').valueOf()
      return itemDate >= geDate && itemDate <= upperDate
    }
  }

  static SamplesFilterInternal(gridRef, passedFilter, actionFilters, holidays) {
    if (Object.keys(actionFilters).length > 0) {

      const geMoment = FilterHelper.dateToMoment(actionFilters.Date.Date.ge.value)
      const leMoment = FilterHelper.dateToMoment(actionFilters.Date.Date.le.value)
      const geDate = geMoment.clone().startOf('day').valueOf()
      const upperDate = FilterHelper.getInvoiceUpperBoundMoment(geMoment, leMoment, holidays).valueOf()

      gridRef.collectionView.filter = (item) => {
        let filCols = passedFilter.filterColumns
        if (!filCols) {
          filCols = passedFilter.grid.columns.map((col) => col.binding)
        }
        for (let i = 0; i < filCols.length; i++) {
          let colBinding = filCols[i]

          let colFil = passedFilter.getColumnFilter(colBinding)

          if (!colFil.apply(item)) {
            return false
          }
        }

        const itemDate = FilterHelper.dateToMoment(item.Date).startOf('day').valueOf()
        return itemDate >= geDate && itemDate <= upperDate
      }
    }
  }

  static OrdersFilterExternal(filterTypes, holidays) {
    if (!filterTypes) return () => true

    const { ShpDate, not, Hold } = filterTypes.OrderType

    if (ShpDate && not) {
      const today = FilterHelper.todayInEDT().startOf('day')
      const nextShpDate = FilterHelper.getNextShipDate(today, holidays).format('YYYY-MM-DD')

      return (item) => {
        const hasHold = ['MO', 'BO', 'IN', 'BH', 'SM'].includes(item.Hold)
        const shipDateTime = item.ShpDate
        const isNextShpDate = FilterHelper.compareDates(nextShpDate, shipDateTime)
        return !hasHold && isNextShpDate
      }
    }

    if (Hold && Hold.in) {
      return ({ Hold }) => ['MO', 'BO', 'IN', 'BH'].includes(Hold)
    }

    if (not) {
      return ({ Hold }) => !['MO', 'BO', 'IN', 'BH', 'SM'].includes(Hold)
    }

    if (Hold === 'SM') {
      return ({ Hold }) => Hold === 'SM'
    }

    return () => true
  }

  static OrdersFilterInternal(gridRef, passedFilter, actionFilters, holidays) {
    if (Object.keys(actionFilters).length > 0) {
      const { OrderType: { ShpDate, not, Hold } } = actionFilters

      gridRef.collectionView.filter = (item) => {
        let filCols = passedFilter.filterColumns
        if (!filCols) {
          filCols = passedFilter.grid.columns.map((col) => col.binding)
        }
        for (let i = 0; i < filCols.length; i++) {
          let colBinding = filCols[i]
          let colFil = passedFilter.getColumnFilter(colBinding)
          if (!colFil.apply(item)) {
            return false
          }
        }

        if (ShpDate && not) {
          const today = FilterHelper.todayInEDT().startOf('day')
          const nextShpDate = FilterHelper.getNextShipDate(today, holidays).format('YYYY-MM-DD')
          const hasHold = ['MO', 'BO', 'IN', 'BH', 'SM'].includes(item.Hold)
          const shipDateTime = item.ShpDate
          const isNextShpDate = FilterHelper.compareDates(nextShpDate, shipDateTime)

          return !hasHold && isNextShpDate
        }

        if (Hold && Hold.in) {
          return ['MO', 'BO', 'IN', 'BH'].includes(item.Hold)
        }

        if (not) {
          return !['MO', 'BO', 'IN', 'BH', 'SM'].includes(item.Hold)
        }

        if (Hold === 'SM') {
          return item.Hold === 'SM'
        }

        return true
      }
    }
  }
}

export default Filters
